//
// Copyright 2023 DXOS.org
//
export const trace = {
    begin: ({ id, parentId, data }) => {
        return {
            span: {
                command: 'begin',
                id,
                parent: parentId,
                data
            }
        };
    },
    end: ({ id, status, data }) => {
        return {
            span: {
                command: 'end',
                id,
                status,
                data
            }
        };
    },
    update: ({ id, data }) => {
        return {
            span: {
                command: 'update',
                id,
                data
            }
        };
    },
    error: ({ id, error, data }) => {
        return {
            span: {
                command: 'end',
                id,
                status: 'error',
                data: {
                    errorMessage: error.message,
                    errorName: error.name,
                    errorStack: error.stack,
                    ...data
                }
            }
        };
    }
};
//# sourceMappingURL=tracing.js.map